export const resetToFirstDayOfMonth = () => {
  const currentDate = new Date();
  const firstDayOfMonth = new Date(
    currentDate.getFullYear(),
    currentDate.getMonth(),
    1
  );
  return firstDayOfMonth.toLocaleDateString('pt-br').toString();
};
